import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <div className="hero-section">
        <h1>Privacy Policy</h1>
        <p className="subtitle">How we protect and handle your information</p>
      </div>

      <div className="content-section">
        <div className="privacy-grid">
          <div className="privacy-card">
            <h2>Information We Collect</h2>
            <div className="privacy-content">
              <h3>Personal Information</h3>
              <p>When you use our services, we may collect:</p>
              <ul>
                <li>Name and contact information</li>
                <li>Business details and location</li>
                <li>Service history and preferences</li>
                <li>Payment information</li>
              </ul>

              <h3>Usage Information</h3>
              <p>We automatically collect:</p>
              <ul>
                <li>Device and browser information</li>
                <li>IP address and location data</li>
                <li>Usage patterns and preferences</li>
                <li>Service interaction history</li>
              </ul>
            </div>
          </div>

          <div className="privacy-card">
            <h2>How We Use Your Information</h2>
            <div className="privacy-content">
              <p>We use collected information to:</p>
              <ul>
                <li>Connect you with repair services</li>
                <li>Process payments and transactions</li>
                <li>Improve our services and user experience</li>
                <li>Send important updates and notifications</li>
                <li>Prevent fraud and ensure security</li>
              </ul>
            </div>
          </div>

          <div className="privacy-card">
            <h2>Information Sharing</h2>
            <div className="privacy-content">
              <p>We may share information with:</p>
              <ul>
                <li>Service providers in our network</li>
                <li>Payment processors</li>
                <li>Analytics and security services</li>
                <li>Legal authorities when required</li>
              </ul>
              <p>We never sell your personal information to third parties.</p>
            </div>
          </div>

          <div className="privacy-card">
            <h2>Data Security</h2>
            <div className="privacy-content">
              <p>We protect your data through:</p>
              <ul>
                <li>Encryption of sensitive information</li>
                <li>Regular security audits</li>
                <li>Access controls and monitoring</li>
                <li>Secure data storage practices</li>
              </ul>
            </div>
          </div>

          <div className="privacy-card">
            <h2>Your Rights</h2>
            <div className="privacy-content">
              <p>You have the right to:</p>
              <ul>
                <li>Access your personal information</li>
                <li>Request data correction or deletion</li>
                <li>Opt-out of marketing communications</li>
                <li>Export your data</li>
              </ul>
            </div>
          </div>

          <div className="privacy-card">
            <h2>Contact Us</h2>
            <div className="privacy-content">
              <p>For privacy-related inquiries:</p>
              <div className="contact-info">
                <p>Email: privacy@hotsiderepairs.com</p>
                <p>Phone: (800) 123-4567</p>
                <p>Address: New York, NY 10001</p>
              </div>
              <a href="/contact" className="contact-button">Contact Us</a>
            </div>
          </div>
        </div>

        <div className="update-info">
          <p>Last updated: February 2025</p>
        </div>
      </div>

      <style>
        {`
          .privacy-page {
            min-height: 100vh;
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #fff;
          }

          .hero-section {
            padding: 6rem 2rem;
            text-align: center;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-bottom: 4px solid #ff6b35;
            position: relative;
          }

          .hero-section h1 {
            font-size: 3.5rem;
            font-weight: 800;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          }

          .subtitle {
            font-size: 1.5rem;
            color: rgba(255,255,255,0.9);
            max-width: 800px;
            margin: 0 auto;
            font-weight: 300;
          }

          .content-section {
            max-width: 1200px;
            margin: 0 auto;
            padding: 4rem 2rem;
          }

          .privacy-grid {
            display: grid;
            gap: 2rem;
            margin-bottom: 4rem;
          }

          .privacy-card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            padding: 2rem;
            border: 2px solid rgba(255,255,255,0.1);
            transition: all 0.3s ease;
          }

          .privacy-card:hover {
            border-color: rgba(255, 107, 53, 0.2);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.1);
          }

          .privacy-card h2 {
            font-size: 2rem;
            color: #ff6b35;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
          }

          .privacy-content {
            color: rgba(255,255,255,0.9);
          }

          .privacy-content h3 {
            font-size: 1.5rem;
            color: #fff;
            margin: 1.5rem 0 1rem;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .privacy-content p {
            font-size: 1.1rem;
            line-height: 1.6;
            margin-bottom: 1rem;
          }

          .privacy-content ul {
            list-style-type: none;
            padding: 0;
            margin: 0 0 1.5rem;
          }

          .privacy-content ul li {
            position: relative;
            padding-left: 1.5rem;
            margin-bottom: 0.75rem;
            font-size: 1.1rem;
            line-height: 1.5;
          }

          .privacy-content ul li::before {
            content: '•';
            color: #ff6b35;
            position: absolute;
            left: 0;
            font-weight: bold;
          }

          .contact-info {
            background: linear-gradient(145deg, #383838, #2a2a2a);
            padding: 1.5rem;
            border-radius: 8px;
            margin: 1.5rem 0;
            border: 1px solid rgba(255,255,255,0.1);
          }

          .contact-info p {
            margin-bottom: 0.5rem;
          }

          .contact-button {
            display: inline-block;
            background: linear-gradient(145deg, #ff6b35, #e65d2e);
            color: white;
            text-decoration: none;
            padding: 1rem 2rem;
            border-radius: 6px;
            font-size: 1.1rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            transition: all 0.3s ease;
            margin-top: 1rem;
          }

          .contact-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.2);
          }

          .update-info {
            text-align: center;
            color: rgba(255,255,255,0.7);
            font-size: 1rem;
            margin-top: 2rem;
            padding-top: 2rem;
            border-top: 1px solid rgba(255,255,255,0.1);
          }

          @media (max-width: 768px) {
            .hero-section h1 {
              font-size: 2.5rem;
            }

            .subtitle {
              font-size: 1.25rem;
            }

            .content-section {
              padding: 2rem 1rem;
            }

            .privacy-card h2 {
              font-size: 1.75rem;
            }

            .privacy-content h3 {
              font-size: 1.25rem;
            }

            .privacy-content p,
            .privacy-content ul li {
              font-size: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Privacy;